<template>
  <div class="l_homepage">
    <header>NEWS &amp; TOPICS</header>
    <NewsTab v-if="isExistPremium" @click="tapPremium" />
    <label for="foryou" class="foryou" v-if="this.isExistForYou">
      <input type="checkbox" id="foryou" v-model="checkForYou" />&nbsp;
      <span>「あなただけ」のお知らせのみ表示する</span>
    </label>
    <div v-if="this.currentNewsList">
      <!-- 重要情報 -->
      <important-information
        v-for="(item, index) in this.currentNewsList"
        :key="index"
        :id="item.id"
        :title="item.caption"
        :url="item.url"
        :isImportant="item.kind"
        @click="() => tapAction(item.id, item.url, item.caption, infoImportant)"
      />
      <!-- News情報 -->
      <div class="l_contents">
        <news-panel
          v-for="(item, index) in this.currentNewsList"
          :key="index"
          :url="item.url"
          :image="item.thumb_url"
          :title="item.caption"
          :date="item.date"
          :category="item.category_id"
          :isImportant="item.kind"
          :youtubeId="item.youtube_id"
          @click="() => tapAction(item.id, item.url, item.caption, infoNews)"
        />
      </div>
    </div>

    <!-- Popup背景  -->
    <div
      class="l_popup__cover animation_background"
      v-if="this.popups.length > 0"
    ></div>

    <!-- Popupパネル -->
    <home-popup
      v-for="(item, index) in this.popups"
      :key="`popup_${index}_${item.id}`"
      :id="item.id"
      :title="item.caption"
      :image="item.thumb_url"
      :isPopup="item.is_popup"
      @close="() => tapClose(item.id, item.caption)"
      @navigate="
        () => tapAction(item.id, item.url, item.caption, infoPopupDetail)
      "
    />

    <!-- エラーパネル -->
    <template v-if="this.isError">
      <error-popup
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="'もう一度試す'"
        @submit="() => tapRetryFetch()"
        @close="() => tapErrorClose()"
      />
    </template>

    <VersionCheck :show="versionAlert" :on-close="closeAlert" :msg="errorMsg" />
  </div>
</template>

<script>
import NewsTab from './NewsTab.vue'
import ImportantInformation from '@/components/Home/ImportantInformation.vue'
import NewsPanel from '@/components/NewsPanel.vue'
import HomePopup from '@/components/Modal/HomePopup.vue'
import ErrorPopup from '@/components/Modal/ErrorPopup.vue'
import DateFormatter from '../../utils/DateFormatter.js'
import { FactoryTrack, ContentsType } from '../../constant/firebase'
import { mapActions, mapGetters } from 'vuex'
import { ErrorCode, ErrorMessage } from '@/api/APIClient'
import VersionCheck from '../FAQWalkVersionCheck'

export default {
  name: 'Home',
  components: {
    NewsTab,
    ImportantInformation,
    NewsPanel,
    HomePopup,
    ErrorPopup,
    VersionCheck
  },
  data: function() {
    return {
      idQueryString: 'id',
      notificationKey: 'notification',
      condition: '', // URLにidがついていれば、ここに入ります。
      isError: false,
      errorMessage: '',
      errorTitle: '',
      debugToken: '',
      infoNews: ContentsType.InfoNews,
      infoImportant: ContentsType.InfoImportant,
      infoPopupDetail: ContentsType.InfoPopupDetail,
      isLoaded: false,
      isAndroid: false,
      currentNewsList: [],
      userType: '0',
      isExistForYou: false,
      checkForYou: false,
      versionAlert: false,
      errorMsg: ''
    }
  },
  computed: {
    ...mapGetters({
      newsList: 'Home/newsList',
      popups: 'Home/popups',
      lastUpdated: 'Home/lastUpdated',
      isBadge: 'Home/isBadge'
    }),
    isExistPremium: function() {
      return this.userType === '1' || this.userType === '2'
    }
  },
  watch: {
    $route(to, from) {
      console.log(to, from)
      if (!this.isLoaded) return
      this.__checkQuery()
      this.__checkAutoNavigate()
    },
    // popup表示している間はスクロール固定する、App.vueにisFixedが設定される
    popups: function(values) {
      const isFixed = values.length > 0
      this.action_ToggleModal(isFixed)
    },
    // Badgeつけるかどうかはここで決める
    lastUpdated: function(value) {
      this.actionUnreadChanged(this.isBadge)
    },
    newsList: function(val) {
      this.isExistForYou = val.some(item => {
        return item.use_user_id === '1' && item.target_user_type === '0'
      })
    },
    checkForYou: function(checked) {
      this.currentNewsList = this.newsList.filter(data => {
        return (
          data.target_user_type === '0' &&
          (checked ? data.use_user_id === '1' : true)
        )
      })
      console.log('current', this.currentNewsList)
    }
  },
  created: function() {
    this.__checkAndroid()
    this.__checkQuery()
    this.requestUserInfo()
  },
  mounted: function() {
    // 必ずページトップから始める
    setTimeout(() => {
      window.scrollTo(0, 1)
    }, 500)
  },
  beforeDestroy: function() {
    // ページ繊維でバッジ解除
    this.actionUnreadChanged('0')
  },
  methods: {
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Modal', ['action_ToggleModal']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionUnreadChanged',
      'actionCallNewsDetail',
      'actionNavigateTo',
      'actionVer5_2'
    ]),
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Home', [
      'action_FetchInfo',
      'action_SelectDetailNews',
      'action_DeletePopup'
    ]),

    tapAction(id, url, caption, type) {
      // Firebase Event track
      try {
        this.trackEvent(FactoryTrack.createInfoNews(id, caption, type))
      } catch (e) {
        console.log(e)
      }

      if (url !== '') {
        // external link
        this.navigateToRedirectDetail(id, url)
      } else {
        // internal link
        this.navigateToDetail(id)
      }
    },
    // URLがあれば、外部ページを詳細ページとして表示
    async navigateToRedirectDetail(id, url) {
      this.actionToggleLoading(true)
      window.scrollTo(0, 0)
      this.updateLocalStorage(id)
      this.action_SelectDetailNews(id)
      setTimeout(() => {
        this.actionToggleLoading(false)
      }, 500)
      const isInvalidVersion = await this.actionVer5_2()
      console.log('isInvalidVersion', isInvalidVersion)
      console.log(url)
      console.log(process.env.VUE_APP_BUYC_ENDPOINT)
      if (isInvalidVersion !== 0 && url.startsWith(process.env.VUE_APP_BUYC_ENDPOINT)) {
        console.log('show alert')
        this.versionAlert = isInvalidVersion
        this.errorMsg =
          'キャンペーンへの参加には、アプリバージョン5.2.0以上が必要です。<br />最新版のアプリにアップデートしてください。'
        this.actionToggleLoading(false)
        return
      }
      location.href = url
    },
    //  詳細ページへの遷移
    navigateToDetail(id) {
      try {
        this.updateLocalStorage(id)
        this.action_SelectDetailNews(id)
        this.$router.push({ name: 'HomeDetail' })
        // this.$router.push({ path: `/home/${id}` })
      } catch (e) {
        console.log(e)
      }
    },
    // クローズボタンを
    tapClose(id, caption) {
      this.trackEvent(FactoryTrack.createInfoPopupClose(id, caption))
      this.updateLocalStorage(id)
      this.action_DeletePopup(id)
    },
    // ローカルストレージデータの更新
    updateLocalStorage(id) {
      const key = 'news_' + id
      if (window.localStorage) {
        window.localStorage.setItem(key, 1)
      }
    },
    // エラーポップアップ閉じるボタン
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
      this.isError = false
    },
    // 最新データを取得
    tapRetryFetch() {
      this.trackEvent(FactoryTrack.createErrorRetry())
      this.$router.go()
    },
    // ユーザーデータ取得
    requestUserInfo() {
      try {
        const accTime = new DateFormatter().format(new Date())
        window.receivedToken = payload => {
          const json = JSON.parse(payload)
          this.debugToken = json
          this.userType = json.user_type
          this.fetchHomeData(json.app_token, accTime, json.user_id)
          window.receivedToken = null
        }
        this.actionRequestToken({ apiType: '0', acc_time: accTime })
      } catch (e) {
        // ローカルコール用
        this.createErrorModal(
          ErrorCode.CODE_ERROR_TOKEN,
          ErrorMessage.MSG_ERROR_TOKEN
        )
        console.log(e)
        // this.fetchHomeData('', '', '')
      }
    },
    // Homeデータを取得
    async fetchHomeData(token, accTime, userId) {
      this.actionToggleLoading(true)
      try {
        await this.action_FetchInfo({
          token: token,
          accTime: accTime,
          userId: userId
        })
        setTimeout(() => {
          this.actionToggleLoading(false)
        }, 500)
        this.isLoaded = true
        this.__checkQuery()
        this.__checkAutoNavigate() // URLクエリから詳細ページへ移動する
        // filter infolist with target_user_type to get normal infolist
        this.currentNewsList = this.newsList.filter(
          data => data.target_user_type === '0'
        )
      } catch (e) {
        this.actionToggleLoading(false)
        // console.error(e)
        if (e.code !== undefined || e.code !== '0000000') {
          this.createErrorModal(e.code, e.message)
          this.isLoaded = false
        }
      }
    },
    // URLのQueryパラメータを調べる
    __checkQuery() {
      this.condition = this.$route.query[this.idQueryString]
      if (!this.condition || this.condition === '') {
        window.localStorage.setItem(this.notificationKey, '')
      }
    },
    // URLクエリーから詳細ページに遷移
    __checkAutoNavigate() {
      try {
        const news = this.currentNewsList.find(
          news => news.id === this.condition
        )
        const local = window.localStorage.getItem(this.notificationKey)
        if (news) {
          if (local === news.id) {
            window.localStorage.setItem(this.notificationKey, '') // リセットする、重複通知を有効にするため
            window.history.back() // 重複しているときは、さらに戻す、左肩の戻るボタンを消すため
            return
          }
          if (news.url !== '') {
            this.navigateToRedirectDetail(this.condition, news.url) // URLがあれば外部リンクへ
          } else {
            this.navigateToDetail(this.condition)
          }
          window.localStorage.setItem(this.notificationKey, news.id) // Vueの詳細ページ移動時のみLocalStorageで管理する
        }
      } catch (e) {
        console.log(e)
      }
    },
    // Error Modalを作成する
    createErrorModal(code, message) {
      this.errorMessage = message
      this.errorTitle = 'エラー ' + code
      this.errorCode = code
      this.isError = true
    },
    __checkAndroid() {
      const ua = window.navigator.userAgent
      if (ua.indexOf('Android') >= 0) {
        this.isAndroid = true
      }
    },
    tapPremium() {
      this.actionNavigateTo('6') // 5:プレミアム画面
    },
    closeAlert: function() {
      this.versionAlert = 0
    }
  }
}
</script>

<style scoped lang="scss">
.l_homepage {
  padding: 15px 12px;

  .foryou {
    color: #66160E;
    font-weight: bold;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
  }
}

.l_homepage header {
  margin: 0px auto 15px;
  font-family: Avenir;
  font-size: 15px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #66160E;
}

.l_contents {
  width: 100%;
  margin-top: 10px;
  padding-bottom: 40px;
}

/* popup背景 */
.l_popup__cover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
}

/* 背景表示のアニメーション */
.animation__background {
  animation: fadeIn 0.4s ease normal 0s none running;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
